// Header behavior:
//  - over a dark hero the nav is transparent; once scrolled past the hero it
//    gains `.is-solid` (warm surface + subtle shadow).
//  - mobile menu toggle (`[data-nav-toggle]` / `.n-header--open`).
// Idempotent; safe to call on every turbolinks:load.

export function initHeader(root = document) {
  const header = root.querySelector("[data-wfc-header]");
  if (!header || header.hasAttribute("data-header-bound")) return;
  header.setAttribute("data-header-bound", "");

  const solidAfter = parseInt(header.getAttribute("data-solid-after") || "24", 10);

  // `.is-solid` (border + soft shadow, or solid bg on transparent headers) once
  // the user scrolls past the threshold. Works for both light and transparent headers.
  const onScroll = () => header.classList.toggle("is-solid", window.scrollY > solidAfter);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const toggle = header.querySelector("[data-nav-toggle]");
  if (toggle) {
    toggle.addEventListener("click", () => {
      const open = header.classList.toggle("n-header--open");
      toggle.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
    });
  }
}
